
import InsuranceTable from "../component/insurance/InsuranceTable";
import { Route,Routes } from 'react-router-dom';

const InsurancePlanning = () => {
    return (
        <div>
            <Routes>
            <Route path="/"  element={<InsuranceTable/>}/>
            </Routes>
            
        </div>
           
    );
}

export default InsurancePlanning;
